import React from 'react'
import { css } from '@emotion/react'

import LiveChatLogo from 'gatsby-theme-marketplace-base/src/assets/icons/livechat-logo.inline.svg'
import ChatBotLogo from 'gatsby-theme-marketplace-base/src/assets/icons/chatbot-logo.inline.svg'
import HelpDeskLogo from 'gatsby-theme-marketplace-base/src/assets/icons/helpdesk-logo.inline.svg'
import KnowledgeBaseLogo from 'gatsby-theme-marketplace-base/src/assets/icons/knowledgebase-logo.inline.svg'
import OpenWidgetLogo from 'gatsby-theme-marketplace-base/src/assets/icons/openwidget-logo.inline.svg'

import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

const productsContainerCss = css`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  order: -1;

  p {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.4;
  }

  div {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2rem 4rem;

    > a {
      color: inherit;

      &:hover {
        color: inherit;
      }
    }
  }

  ${mediaQueries.mediumScreen()} {
    order: 1;
  }
`

const productLogoCss = (small) => css`
  width: auto;
  height: ${small ? '15px' : '17px'};
`

const productsList = [
  {
    href:
      'https://www.livechat.com/?utm_source=text.com%2Fmarketplace&amp;utm_medium=referral&amp;utm_campaign=productbar',
    Logo: LiveChatLogo,
  },
  {
    href:
      'https://www.chatbot.com/?utm_source=text.com%2Fmarketplace&amp;utm_medium=referral&amp;utm_campaign=productbar',
    Logo: ChatBotLogo,
  },
  {
    href:
      'https://www.helpdesk.com/?utm_source=text.com%2Fmarketplace&amp;utm_medium=referral&amp;utm_campaign=productbar',
    Logo: HelpDeskLogo,
    small: true,
  },
  {
    href:
      'https://www.knowledgebase.com/?utm_source=text.com%2Fmarketplace&amp;utm_medium=referral&amp;utm_campaign=productbar',
    Logo: KnowledgeBaseLogo,
    small: true,
  },
  {
    href:
      'https://www.openwidget.com/?utm_source=text.com%2Fmarketplace&amp;utm_medium=referral&amp;utm_campaign=productbar',
    Logo: OpenWidgetLogo,
  },
]

const ProductsBar = () => {
  return (
    <div css={productsContainerCss}>
      <p>Our powerful products</p>
      <div>
        {productsList.map(({ href, Logo, small }) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer">
            <Logo css={productLogoCss(small)} />
          </a>
        ))}
      </div>
    </div>
  )
}

export default ProductsBar
